<template>
    <Table @open-dialog="OpenDialog" @get-data="GetLists" :refindex="this.list.refindex"
        :constindex="this.list.constindex" :data="data"></Table>  
</template>
<script>
import Table from "./Components/Tables/Table.vue"; 


export default {
    components: {
        Table 
    },
    data() {
        return {
            loading: null,
            data: [
                {
                    id: 1,
                    descr: "Tərəflərin qarşılıqlı razılığı ilə Sığortalı I-in hüquq və vəzifələri Sığortalı II-yə keçə bilər.",
                    created: "2025-08-01 14:32",
                    updated: "2025-08-05 10:12"
                },
                {
                    id: 2,
                    descr: "Sığorta olunan öz iş yerini dəyişdirdiyi təqdirdə, Sığortalı, işçinin xeyrinə bağlanmış həyatın yığım sığortası şəhadətnaməsi üzrə öz hüquq və vəzifələrini Sığortaçının və yeni işəgötürənin razılığı ilə sonuncuya ötürür. Bu halda sığorta olunanın yeni işəgötürəni bu şəhadətnamə üzrə Sığortalı qismində çıxış edir.",
                    created: "2025-08-02 09:15",
                    updated: "2025-08-10 16:45"
                },
                {
                    id: 3,
                    descr: "Şəhadətnamə bağlanarkən və sığorta məbləği artırılarkən Sığortaçı Sığorta olunanın müvafiq ərizə formasını doldurmasını və şəhadətinin tibbi müayinədən keçməsini tələb etmək hüququna malikdir. Bu zaman müayinənin aparılacağı tibb müəssisəsi Sığortaçı ilə razılaşdırılmaqla Sığortaçı tərəfindən müəyyən edilir. Sığorta olunanın səhhəti ilə bağlı onun tərəfindən təqdim edilən məlumat əsasında və tibbi müayinənin nəticəsindən asılı olaraq Sığortaçı sığorta şərtlərinin dəyişiklikləri etməklə hüququna malikdir. Sığorta olunan tibbi müayinədən keçməkdən imtina edəcəyi halda Sığortaçı həmin şəxslə Sığorta şəhadətnaməsinin bağlanmasından və ya artıq bağlanmış şəhadətnaməyə əlavı yazmaqdan imtina edə bilər.",
                    created: "2025-08-03 11:22",
                    updated: "2025-08-11 13:05"
                },
                {
                    id: 4,
                    descr: "Sığorta ödənişi faydalanan şəxs tərəfindən gələcəkdə təqdim olunacaq bank rekvizitləri üzrə bank köçürməsi ilə həyata keçiriləcək.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 5,
                    descr: "Sığorta olunan bu şəhadətnamənin qüvvədə olduğu müddət ərzində Bankdan kredit götürərsə, və həmin kreditin qaytarılmasının təminatı üsulu kimi Sığortaçıya ödənilmiş sığorta haqları çıxış edərsə (girov, zəmanət və s.), Sığorta şəhadətnaməsinə vaxtından əvvəl xitam verildikdə, kredit müddəti bitən tarixə qədər ödənilməməsi halında Bank öz tələblərini Sığortaçı tərəfindən kreditin ödənilməsinin təminatı üsulu kimi çıxış edən pul məbləğinə (sığorta haqlarına) yönəltdikdə (sildikdə), Sığortaçı hüququsunun sığorta məbləğini və ya qaytarılan məbləğini Faydalanan şəxsə (Sığortalıya) ödəmək vəzifəsindən azad olur (Sığortalı həmin məbləği qaldır öz öhdəliyini icra etmiş sayılır).",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 6,
                    descr: "Nəzərə alınır ki, Sığortalının seçiminə və istəyinə əsasən onun ödədiyi sığorta haqları (Deposit bank adı) ASC-də olan {Deposit account number} saylı cari hesaba investisiya edilmişdir, Bank müflis olduqda və ya istənilən başqa səbəbdən {Policy issue date}-ci il tarixli {Policy number} nömrəli annuitet müqaviləsi üzrə Sığortaçı qarşısında öhdəliklərini yerinə yetirə bilmədikdə Sığortaçı, həmin annuitet müqaviləsi üzrə öhdəliklərin icra edilmədiyi müddətdə bu şəhadətnamənin və ya şəhadətnamə üzrə faydalanan şəxslər qarşısında öhdəliklərin icrasından azaddır.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 7,
                    descr: "Əmanət Müqaviləsi üzrə əmanət məbləğin hesablanan faiz dərəcəsi və ya şərtlər dəyişdikdə Sığortaçı sığorta məbləğini və qaytarılan məbləği Əmanət müqaviləsindəki dəyişdirilmiş faiz dərəcəsi və şərtlər əsasında yenidən hesablayıb dəyişdirmək hüququna malikdir. Bu halda Sığorta şəhadətnaməsinə müvafiq dəyişikliklər edilir.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 8,
                    descr: "Bütün ödənişlər və təzminatlar Azərbaycan Respublikasl Mərkəzi Bankının ödəniləcəyi günə olan məzənnəsi əsasında milli valyuta olan Azərbaycan manatı ilə həyata keçirilir.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                },
                {
                    id: 9,
                    descr: "Azərbaycan Respublikasının Mülki Məcəlləsinin 422-ci maddəsində nəzərdə tutulmuş hallı baş verdiyi təqdirdə Sığortaçı şəhadətnaməni birtərəfli qaydada dəyişdirmək hüququna malikdir.",
                    created: "2025-08-04 17:05",
                    updated: "2025-08-12 08:50"
                }
            ],
            list: {
                dialogVis: false,
                object: null,
                refindex: 0,
                constindex: 0
            },
        }
    },
    methods: {
        GetLists() {
            //None
        },
        Insert() {
            if (this.type == 'LIST') {
                this.list.dialogVis = false
                this.GetLists()
            }
            else {
                this.list.refindex = this.list.refindex + 1
                this.det.dialogVis = false
            }
        },
        OpenDialog(index, edit, object, type) {
            this.type = type
            this.list.constindex = index
            if (type == 'LIST') {
                this.list.constindex = index
                this.list.dialogVis = true
                this.list.object = object
            } else if (type == 'DET') {
                this.det.dialogVis = true
                this.det.object = object
            }
            this.editing = edit
        }
    },
    mounted() {
        this.GetLists()
    }
}
</script>